<script>
    import { appManager } from "../AppManagerStore";
</script>

<section class="py-3 py-md-3 bg-light">
    <div class="container">
        <div class="row align-items-center justify-content-center">
            <div class="col-12 text-center client-logos">
                <a href="https://www.brussels.be/">
                    <img
                        src="{$appManager.PublicUrl}img/clients/stad-brussel.png"
                        alt="Brussel" /></a>
                <a href="https://stad.gent/nl">
                    <img
                        src="{$appManager.PublicUrl}img/clients/gent.png"
                        alt="Gent" /></a>
                <a href="https://www.mechelen.be/">
                    <img
                        src="{$appManager.PublicUrl}img/clients/stad-mechelen.png"
                        alt="Mechelen" /></a>
                <a href="https://www.izegem.be/">
                    <img
                        src="{$appManager.PublicUrl}img/clients/izegem.svg"
                        alt="Izegem" /></a>
            </div>
        </div>
        <!-- <div class="row align-items-center justify-content-center">
            <div class="col-12 text-center client-logos">
                <a href="https://www.billiebonkers.be/"
                    ><img
                        src="{$appManager.PublicUrl}img/clients/billie-bonkers.svg"
                        alt="Billie Bonkers" /></a>
                <a href="https://www.suunta.be/">
                    <img
                        src="{$appManager.PublicUrl}img/clients/suunta.png"
                        alt="Suunta" /></a>
            </div>
        </div> -->
    </div>
</section>
